<template>
  <bpb-scroller-item
    v-if="scrollerComponent === SCROLLER_SHOP_COMPONENT.default"
  >
    <slot name="teaser" />
  </bpb-scroller-item>
  <bpb-scroller-gallery-item
    v-else-if="scrollerComponent === SCROLLER_SHOP_COMPONENT.gallery"
    class="sticker-wrapper"
  >
    <slot name="picture" />
    <template slot="description">
      <slot name="teaser" />
    </template>
  </bpb-scroller-gallery-item>
</template>

<script>
import { SCROLLER_SHOP_COMPONENT } from './bpb-scroller-shop.vue';
export default {
  inject: ['scrollerShopContext'],
  data() {
    return {
      SCROLLER_SHOP_COMPONENT,
    };
  },
  computed: {
    isAboveLgBreakpoint() {
      return this.$store.getters['window/breakpointUp']('lg');
    },
    scrollerComponent() {
      return this.scrollerShopContext.scrollerComponent;
    },
  },
};
</script>
